import React from 'react';
import {
  FaTools, FaChartLine, FaRoad, FaClipboardCheck, FaBullseye, FaPlusCircle
} from 'react-icons/fa';
import styled from 'styled-components';

const iconMap = {
  'FaTools': <FaTools style={{ color: '#3F51B5' }} />,
  'FaChartLine': <FaChartLine style={{ color: '#009688' }} />,
  'FaRoad': <FaRoad style={{ color: '#FF5722' }} />,
  'FaClipboardCheck': <FaClipboardCheck style={{ color: '#4CAF50' }} />,
  'FaBullseye': <FaBullseye style={{ color: '#FFC107' }} />,
  'FaPlusCircle': <FaPlusCircle style={{ color: '#673AB7' }} />,
};

const NextechCard = ({ icon, title, description }) => {
  return (
    <Card>
      <CardIcon>{iconMap[icon]}</CardIcon>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </Card>
  );
}

export default NextechCard;

const Card = styled.div`
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
   font-family: "Poppins", system-ui;
  padding: 30px 25px;
  max-width: 350px;
  text-align: left;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: calc(50% - 20px);
    max-width: 100%;
  }

  @media (max-width: 480px) {
    width: calc(100% - 20px);
  }
`;

const CardIcon = styled.div`
  width: 70px;
  height: 70px;
  margin-bottom: 20px;
  font-size: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0faff;
  border: 2px solid #e0e0e0;

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
    font-size: 32px;
  }
`;

const CardTitle = styled.h3`
  font-size: 1.1em;
  color: #06334b;
  margin-bottom: 15px;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 1.2em;
  }
`;

const CardDescription = styled.p`
  font-size: 0.9em;
  color: #777;
  line-height: 1.71;
  text-align: justify;

  @media (max-width: 480px) {
    font-size: 0.9em;
  }
`;
